import { useEffect, useState } from 'react';
import { api } from '../services/api';
import { getImageUrl } from '../utils/imageUrl';

/**
 * Resolve breadcrumb title + banner from item banner, page slug, or site default.
 */
export function usePageBanner({ itemLoader, itemId, pageSlug, fallbackTitle, fallbackImage }) {
  const [title, setTitle] = useState(fallbackTitle);
  const [bgImage, setBgImage] = useState(getImageUrl(fallbackImage) || null);

  useEffect(() => {
    let active = true;

    async function load() {
      let item = null;
      let page = null;
      let settings = {};

      if (itemId && itemLoader) {
        try {
          const itemRes = await itemLoader(itemId);
          item = itemRes?.data ?? null;
        } catch {
          item = null;
        }
      }

      if (pageSlug) {
        try {
          const pageRes = await api.getPage(pageSlug);
          page = pageRes?.data ?? null;
        } catch {
          page = null;
        }
      }

      try {
        const settingsRes = await api.getSettings();
        settings = settingsRes?.data || {};
      } catch {
        settings = {};
      }

      if (!active) return;

      if (item?.title || item?.name) setTitle(item.title || item.name);
      else if (page?.title) setTitle(page.title);
      else setTitle(fallbackTitle);

      const banner =
        getImageUrl(item?.bannerImg || item?.banner_image) ||
        getImageUrl(fallbackImage) ||
        getImageUrl(page?.banner_image || page?.bannerImg) ||
        getImageUrl(settings.default_breadcrumb_image) ||
        null;

      setBgImage(banner || null);
    }

    load();
    return () => {
      active = false;
    };
  }, [itemId, pageSlug, fallbackTitle, fallbackImage, itemLoader]);

  return { title, bgImage };
}

export default usePageBanner;
